package com.wintermar.inspection.feature.presentation.inspection.answer.widget.choice_answer

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.graphql.type.InspectionAnswerType

@Composable
fun InspectionAnswerType.contentColor(orderPosition: Int): ChoiceAnswerColorModel {
    val themeColor = LocalAppTheme.current.color

    val color = when {
        this == InspectionAnswerType.YES_NO_NA && orderPosition == 1 ||
                this == InspectionAnswerType.COMPLIANCE_NON_COMPLIANCE_NA && orderPosition == 1
            -> ChoiceAnswerColorModel(
            backgroundColor = themeColor.surface.semantic.success.subtle.default,
            borderColor = themeColor.border.input.success,
            textColor = themeColor.text.success.default,
            badgeColor = themeColor.surface.semantic.success.bold.default
        )

        this == InspectionAnswerType.YES_NO_NA && orderPosition == 2 ||
                this == InspectionAnswerType.COMPLIANCE_NON_COMPLIANCE_NA && orderPosition == 2 ->
            ChoiceAnswerColorModel(
                backgroundColor = themeColor.surface.semantic.error.subtle.default,
                borderColor = themeColor.border.input.error,
                textColor = themeColor.text.error.default,
                badgeColor = themeColor.surface.semantic.error.bold.default
            )

        else -> ChoiceAnswerColorModel(
            backgroundColor = themeColor.surface.gray.subtle.default,
            borderColor = themeColor.border.bold,
            textColor = themeColor.text.default,
            badgeColor = themeColor.surface.gray.bold.default
        )
    }

    return remember(this, themeColor) {
        color
    }
}
